import { render } from "./CookiesLineCard.vue?vue&type=template&id=460b56e8&scoped=true&ts=true"
import script from "./CookiesLineCard.vue?vue&type=script&lang=ts"
export * from "./CookiesLineCard.vue?vue&type=script&lang=ts"

import "./CookiesLineCard.vue?vue&type=style&index=0&id=460b56e8&scoped=true&lang=css"
import "./CookiesLineCard.vue?vue&type=style&index=1&id=460b56e8&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460b56e8"]])

export default __exports__